import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import type {LivePenaltiesModuleState} from "../models/live-penalties-module.state";
import type {LivePenaltiesModuleController} from "../live-penalties-module.controller";
import {LIVE_PENALTIES} from "../live-penalties-module.consts";
import {LivePenaltiesModuleCloseEventModel} from "../models/live-penalties-module.close.event-model";

export class LivePenaltiesModuleCloseEventHandler extends AnalyticsEventHandler {
  type = LIVE_PENALTIES.ACTION_TYPES.onClose;
  state: LivePenaltiesModuleState;
  controller: LivePenaltiesModuleController;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = LivePenaltiesModuleCloseEventModel;
  }
}
